import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
    NConfigProvider,
    GlobalThemeOverrides,
    NMessageProvider,
} from "naive-ui";
import MessageContent from "@/views/layout/MessageContent.vue";
import TitleBar from "@/views/layout/TitleBar.vue";
import FooterBar from "@/views/layout/FooterBar.vue";
import { useStore } from "vuex";
import { MessageAlert } from "./composables/useMessageAlert";
import { i18nCtx, Language_Token_key } from "./i18n/index";
import { useNavigatorSystem } from "@/composables/useNaviSystem";
import NavBar from "@/mobile/layout/NavBar.vue"; // 移动端的navBar


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const store = useStore();
const { isMobile } = useNavigatorSystem();

const curRouterIsHome = ref<boolean>(false);
const themeOverrides: GlobalThemeOverrides = {
    common: {
        primaryColor: "#1195F5",
    },
    Button: {
        textColor: "#000000",
        borderHover: "1px solid rgb(0, 0, 0, 0.7)",
        borderFocus: "1px solid rgb(0, 0, 0, 0.7)",
        borderPressed: "1px solid rgb(0, 0, 0, 0.7)",
    },
    Form: {
        labelTextColor: "rgba(0, 0, 0, 0.60)",
    },
    Input: {
        border: "1px solid rgba(0, 0, 0, 0.20)",
        borderHover: "1px solid rgba(0, 0, 0, 0.20)",
        borderActive: "1px solid rgba(0, 0, 0, 0.20)",
        borderFocus: "1px solid rgba(0, 0, 0, 0.20)",
        boxShadowHover: "1px solid rgba(0, 0, 0, 0.20)",
        boxShadowActive: "1px solid rgba(0, 0, 0, 0.20)",
        boxShadowFocus: "1px solid rgba(0, 0, 0, 0.20)",
        borderRadius: "28px",
        paddingLarge: "0 28px",
    },
    Select: {
        peers: {
            InternalSelection: {
                borderHover: "1px solid rgba(0, 0, 0, 0.20)",
                borderActive: "1px solid rgba(0, 0, 0, 0.20)",
                borderFocus: "1px solid rgba(0, 0, 0, 0.20)",
                boxShadowHover: "1px solid rgba(0, 0, 0, 0.20)",
                boxShadowActive: "1px solid rgba(0, 0, 0, 0.20)",
                boxShadowFocus: "1px solid rgba(0, 0, 0, 0.20)",
                borderRadius: "28px",
                arrowSize: "24px",
                paddingSingle: "0 28px",
                paddingMultiple: "0 28px",
            },
            InternalSelectMenu: {
                borderRadius: "16px",
            }
        },
    },
    Radio: {
        textColor: "#000000",
        textColorDisabled: "rgba(0, 0, 0, 0.20)",
        radioSizeLarge: "24px",
        radioSizeMedium: "18px",
        boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.20)",
        boxShadowActive: "inset 0 0 0 1px #000000",
        boxShadowFocus: "inset 0 0 0 1px #000000",
        boxShadowHover: "inset 0 0 0 1px #000000",
        boxShadowDisabled: "inset 0 0 0 1px rgba(0, 0, 0, 0.20)",
        dotColorActive: "#000000",
    }
};

const routerKey = computed(() => {
    return router.currentRoute.value?.fullPath;
});
const routerName = computed(() => {
    return router.currentRoute.value?.name;
});
const routerPath = computed(() => {
    return router.currentRoute.value?.path;
})
const isMobileRouter = computed(() => {
    return isMobile.value && routerPath.value.indexOf("/mobile") > -1;
});
const isShowNavBarInMobile = computed(() => {
    return router.currentRoute.value?.meta?.showNavBar;
});

watch(
    () => router.currentRoute.value,
    (newValue) => {
        //console.log("router.currentRoute===>", newValue, oldValue);
        if (newValue.name === "Home" && newValue.matched.length > 0) {
            curRouterIsHome.value = true;
        } else {
            curRouterIsHome.value = false;
        }
    },
    { immediate: true }
);

const _fetchUserInfoByApi = async () => {
    try {
        await store.dispatch("user/fetchUserInfo");
    } catch (error: any) {
        const errMess = error?.message || "login failed";
        MessageAlert(errMess);
    }
};

const initSetCacheLanguage = () => {
    //const lang = (window?.navigator.language || "en").toLocaleLowerCase();
    const lang = "en".toLocaleLowerCase();
    const language =
        localStorage.getItem(Language_Token_key) || lang.split("-")[0] || "en";
    i18nCtx.ChangeLanguageAsync(language);
};

onMounted(() => {
    //console.log("reloadApp====>")
    nextTick(() => {
        _fetchUserInfoByApi();

        // console.log("页面即将卸载===刷新页面");
        // initSetCacheLanguage();
    });

    // window.addEventListener("resize", () => {
    //     const isMobileFlag = window.innerWidth <= 774 && isMobile.value;
    // })
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": themeOverrides }, {
    default: _withCtx(() => [
      (isMobileRouter.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!!isShowNavBarInMobile.value)
              ? (_openBlock(), _createBlock(NavBar, {
                  key: 0,
                  "is-home": curRouterIsHome.value
                }, null, 8, ["is-home"]))
              : _createCommentVNode("", true),
            (routerKey.value.indexOf('/post') > -1)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
              : (_openBlock(), _createBlock(_component_router_view, { key: routerKey.value }))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(TitleBar, { "is-home": curRouterIsHome.value }, null, 8, ["is-home"]),
            (routerKey.value.indexOf('/post') > -1)
              ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
              : (_openBlock(), _createBlock(_component_router_view, { key: routerKey.value })),
            _createVNode(FooterBar)
          ], 64)),
      _createVNode(_unref(NMessageProvider), {
        placement: "bottom",
        "container-class": "custom-message-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(MessageContent)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})